import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {Swiper} from 'swiper';
import {SwiperOptions} from "swiper/types";
import {CommitteeDTO, CommitteeService} from '../api/committee-api.service';
import {SpinnerService} from '../shared/services/spinner.service';
import {finalize} from 'rxjs';

@Component({
    selector: 'app-committee',

    templateUrl: './committee.component.html',
    styleUrl: './committee.component.css'
})
export class CommitteeComponent {
    @Input() slides: { image: string, alt: string }[] = [];
    @ViewChild('swiperContainer', {static: true}) swiperContainer!: ElementRef<HTMLDivElement>;
    private swiper: Swiper | null = null;
    committees: CommitteeDTO[] = [];
    selectedCommittee?: CommitteeDTO;
    committeId: any;
    userGroup: any;

    /*committeeMembers = [
      {
        role: 'President',
        name: 'Pradeep Singh Sengar',
        email: 'president@rajputra.org',
        phone: '703-623-0360',
        location: 'DC VA',
        image: 'assets/img/nec/1.jpeg'
      },
      {
        role: 'Vice President',
        name: 'Naresh Chavda',
        email: 'vp@rajputra.org',
        phone: '647-895-6790',
        location: 'Canada',
        image: 'assets/img/nec/2.jpg'
      },
      {
        role: 'General Secretary',
        name: 'Surendra Singh Chauhan',
        email: 'gs@rajputra.org',
        phone: '703-401-8331',
        location: 'DC VA',
        image: 'assets/img/nec/3.jpg'
      },
      {
        role: 'Treasurer',
        name: 'Anita Singh',
        email: 'treasurer@rajputra.org',
        phone: '718-496-4871',
        location: 'NY',
        image: 'assets/img/nec/4.jpg'
      },
      {
        role: 'Chairperson of Education Committee',
        name: 'Dilipsinh Rathod',
        email: 'education@rajputra.org',
        phone: '856-889-4531',
        location: 'NJ',
        image: 'assets/img/nec/5.jpg'
      },
      {
        role: 'Chairperson IT/Magazine',
        name: 'Saraswati (Saru) Singh',
        email: 'magazine@rajputra.org',
        phone: '859-433-6905',
        location: 'AZ',
        image: 'assets/img/nec/6.jpeg'
      },
      {
        role: 'Membership Secretary',
        name: 'Harnath Singh Rathore',
        email: 'membership@rajputra.org',
        phone: '928-600-6811',
        location: 'AZ',
        image: 'assets/img/nec/7.jpg'
      },
      {
        role: 'Chairperson of Cultural Committee',
        name: 'Meenakshi Singh Sarangdevot',
        email: 'cultural@rajputra.org',
        phone: '732-713-1127',
        location: 'NJ',
        image: 'assets/img/nec/8.jpg'
      },
      {
        role: 'Community Relations Secretary',
        name: 'Virendrasinh Zala',
        email: 'community@rajputra.org',
        phone: '262-271-2939',
        location: 'WI',
        image: 'assets/img/nec/9.jpg'
      }
    ];
    */


    committeeMembers = [
        {
            role: 'President',
            name: 'Nareshkumar Chavda',
            email: 'nec@rajputra.org',
            phone: '647-895-6790',
            location: 'Canada',
            image: 'assets/img/nec/1.jpeg'
        },
        {
            role: 'Vice President',
            name: 'Surendra Singh Chauhan',
            email: 'nec@rajputra.org',
            phone: '703-401-8331',
            location: 'DC VA',
            image: 'assets/img/nec/2.jpg'
        },
        {
            role: 'General Secretary',
            name: 'Shweta Singh',
            email: 'nec@rajputra.org',
            phone: '205-515-6003',
            location: 'GA',
            image: 'assets/img/nec/3.jpeg'
        },
        {
            role: 'Treasurer',
            name: 'Pravinsinh Parmar',
            email: 'nec@rajputra.org',
            phone: '630-965-0898',
            location: 'IL',
            image: 'assets/img/nec/4.jpeg'
        },
        {
            role: 'Education Secretary',
            name: 'Meenakshi Sarangdevot',
            email: 'nec@rajputra.org',
            phone: '732-713-1127',
            location: 'NJ',
            image: 'assets/img/nec/5.jpg'
        },
        {
            role: 'Magazine Secretary',
            name: 'Mahendra Singh Jadon',
            email: 'nec@rajputra.org',
            phone: '571-498-3099',
            location: 'VA',
            image: 'assets/img/nec/6.jpeg'
        },
        {
            role: 'Membership Secretary',
            name: 'Ranvijai Singh',
            email: 'nec@rajputra.org',
            phone: '612-229-6927',
            location: '',
            image: 'assets/img/nec/15.jpeg'
        },
        {
            role: 'IT Secretary',
            name: ' Kandarp Singh Sengar',
            email: 'nec@rajputra.org',
            phone: '818-679-0903',
            location: 'TX',
            image: 'assets/img/nec/7.jpeg'
        },
        {
            role: 'Cultural Secretary',
            name: 'Reenaba Chudasama',
            email: 'nec@rajputra.org',
            phone: '5714942446',
            location: 'VA',
            image: 'assets/img/nec/8.jpeg'
        },
        {
            role: 'Community Relations Secretary',
            name: 'Kanaksinh Zala',
            email: 'community@rajputra.org',
            phone: 'nec@rajputra.org',
            location: 'CA',
            image: 'assets/img/nec/9.jpeg'
        },
        {
            role: 'Senior Affairs Secretary',
            name: 'Dilipsinh Rathod',
            email: 'nec@rajputra.org',
            phone: ' 856-889-4531',
            location: 'NJ',
            image: 'assets/img/nec/10.jpeg'
        },
        {
            role: 'Member at Large',
            name: 'Vijaya Raghav Parmar',
            email: 'nec@rajputra.org',
            phone: '267-240-7281',
            location: 'NJ',
            image: 'assets/img/nec/14.jpeg'
        },
        {
            role: ' Member at Large / Sr. Women’s Affairs Co-Chair',
            name: ' Saraswathi Singh',
            email: 'nec@rajputra.org',
            phone: '859-433-6905',
            location: 'AZ',
            image: 'assets/img/nec/13.jpeg'
        }
    ];


    constructor(private committeeService: CommitteeService,
                private spinner: SpinnerService) {
    }


    ngAfterViewInit(): void {
        if (this.swiperContainer && this.swiperContainer.nativeElement) {
            this.swiper = new Swiper(this.swiperContainer.nativeElement, this.getSwiperOptions());
        }
    }

    ngOnInit(): void {
        this.userGroup = sessionStorage.getItem('userGroup') || 'NON_MEMBER';

    }

    ngOnDestroy(): void {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }

    private getSwiperOptions(): SwiperOptions {
        return {
            loop: true,
            spaceBetween: 0,
            resistance: true,
            centeredSlides: true,
            resistanceRatio: 0,
            speed: 500,
            grabCursor: false,
            freeMode: false,
            touchStartPreventDefault: false,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            breakpoints: {
                575: {
                    slidesPerView: 1,
                    loop: false,
                },
                767: {
                    slidesPerView: 1,
                    loop: false,
                },
                991: {
                    slidesPerView: 3,
                    loop: true,
                }
            },
            effect: `coverflow`,
            coverflowEffect: {
                rotate: 10,
                slideShadows: false,
                depth: 220,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },

        };
    }


    viewCommittees(id: string): void {
        this.spinner.show(); // Show spinner while fetching committees
        this.committeeService.getCommitteesByChapterId(id).pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe({

            next: (data) => {
                this.committees = data;
            },
            error: (err) => {
                console.error('Error fetching committee:', err);
            },
        });
    }

    addCommittee(newCommittee: CommitteeDTO): void {
        this.spinner.show(); // Show spinner while creating committee
        this.committeeService.createCommittee(newCommittee).pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe({
            next: (data) => {
                console.log('Committee created:', data);
                this.viewCommittees(this.committeId); // Reload the list
            },
            error: (err) => {
                console.error('Error creating committee:', err);
            },
        });
    }

    updateCommittee(id: string, updatedCommittee: CommitteeDTO): void {
        this.spinner.show(); // Show spinner while updating committee
        this.committeeService.updateCommittee(id, updatedCommittee).pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe({
            next: (data) => {
                console.log('Committee updated:', data);
                this.viewCommittees(this.committeId);  // Reload the list
            },
            error: (err) => {
                console.error('Error updating committee:', err);
            },
        });
    }

    deleteCommittee(id: string): void {
        this.spinner.show(); // Show spinner while deleting committee
        this.committeeService.deleteCommittee(id).pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe({
            next: () => {
                console.log('Committee deleted');
                this.viewCommittees(this.committeId); /// Reload the list
            },
            error: (err) => {
                console.error('Error deleting committee:', err);
            },
        });
    }
}

